'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slick = void 0;
const $ = require("jquery");
require("slick-carousel");
class Slick {
    constructor() {
        $('.bulletSlick').slick({
            arrows: true,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: true,
            slidesToShow: 1,
        });
        $('.bulletSlickSeason').slick({
            arrows: true,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: false,
            slidesToShow: 1,
        });
    }
}
exports.Slick = Slick;
exports.default = Slick;
